import { render, staticRenderFns } from "./coope-stores.vue?vue&type=template&id=cba5161a&"
import script from "./coope-stores.vue?vue&type=script&lang=js&"
export * from "./coope-stores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports